import { INextButtonProps } from "./SelectModelsInterfaces";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { AddDocumentState } from "../../routing/RoutingStates";
export default function NextButton({
  modelState,
  selectedModels,
  selectedArchivedModels,
  startDate,
  endDate,
  isStartDateValid,
  disabledNext,
}: INextButtonProps) {
  const navigate = useNavigate();

  const handleNext = () => {
    const combinedList = [...selectedModels, ...selectedArchivedModels]
      .filter((item) => item.label !== null)
      .sort((a, b) => a.label!.localeCompare(b.label!));
    const addDocumentState: AddDocumentState = {
      selectedCompany: modelState.selectedCompany,
      selectedProductRange: modelState.selectedProductRange,
      isProductCompany: modelState.isProductCompany,
      selectedModels: combinedList,
      productNumbers: null,
      serialNumber: null,
      startDate,
      endDate,
    };
    navigate("AddDocument", {
      state: { addDocumentState },
    });
  };

  return (
    <Row>
      {(selectedModels.length > 0 || selectedArchivedModels.length > 0) &&
        isStartDateValid && (
          <Col className="d-flex justify-content-end">
            <Button
              className="btn btn-primary"
              disabled={disabledNext}
              onClick={handleNext}
            >
              Next
            </Button>
          </Col>
        )}
    </Row>
  );
}
